
import { useState } from "react";
import { AnalyticsCards } from "./AnalyticsCards";
import { SearchAnalyticsChart } from "./SearchAnalyticsChart";
import { TopSearchesTable } from "./TopSearchesTable";
import { TopClickedProductsTable } from "./TopClickedProductsTable";
import { DateRangeFilter } from "./DateRangeFilter";
import { Loader2 } from "lucide-react";
import { getDateRange } from "@/utils/dateRangeUtils";
import { useAnalyticsStats } from "./hooks/useAnalyticsStats";
import { useAnalyticsChart } from "./hooks/useAnalyticsChart";
import { useTopSearches } from "./hooks/useTopSearches";
import { useTopClickedProducts } from "./hooks/useTopClickedProducts";

export const AnalyticsDashboard = () => {
  const [selectedDateRange, setSelectedDateRange] = useState('today');
  const dateRange = getDateRange(selectedDateRange);

  const { data: stats, isLoading: statsLoading } = useAnalyticsStats(selectedDateRange);
  const { data: chartData, isLoading: chartLoading } = useAnalyticsChart(selectedDateRange);
  const { data: topSearches, isLoading: searchesLoading } = useTopSearches(selectedDateRange);
  const { data: topClickedProducts, isLoading: clickedProductsLoading } = useTopClickedProducts(selectedDateRange);

  if (statsLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
        <span className="ml-2 text-lg">Analytics laden...</span>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <DateRangeFilter 
        selectedRange={selectedDateRange} 
        onRangeChange={setSelectedDateRange} 
      />
      
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-4 rounded-lg border border-blue-200">
        <p className="text-blue-800 text-center font-medium">
          Analytics voor: {dateRange.label}
        </p>
      </div>
      
      <AnalyticsCards stats={stats} />
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <SearchAnalyticsChart 
          data={chartData || []} 
          isLoading={chartLoading}
          title={`Activiteit per ${['today', 'yesterday'].includes(selectedDateRange) ? 'Uur' : 'Dag'} (${dateRange.label})`}
        />
        <TopSearchesTable 
          data={topSearches || []} 
          isLoading={searchesLoading}
          title={`Top Zoekopdrachten (${dateRange.label})`}
        />
      </div>
      
      <TopClickedProductsTable 
        data={topClickedProducts || []} 
        isLoading={clickedProductsLoading}
        title={`Top Geklikte Producten (${dateRange.label})`}
      />
    </div>
  );
};
